export default "__VITE_ASSET__BvNAo2hH__"